package meineglasfaser.frontend.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.App
import kotlinx.browser.document
import meineglasfaser.frontend.admin.components.ProvideAdminUserState
import meineglasfaser.frontend.common.PromKobwebApp

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    PromKobwebApp {
        LaunchedEffect(Unit) {
            document.documentElement?.setAttribute("data-theme", "light")
        }
        ProvideAdminUserState {
            content()
        }
    }
}

